"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.associateProductToComponentsUseCase = void 0;
const lodash_1 = require("lodash");
const components_1 = require("@/services/components");
const products_1 = require("@/store/ducks/products");
const associatedComponents_1 = require("@/store/ducks/associatedComponents");
const listAssociatedComponents_1 = require("./listAssociatedComponents");
function associateProductToComponentsUseCase(productId, components) {
    return async (dispatch) => {
        dispatch((0, associatedComponents_1.associateProductToComponents)());
        try {
            const products = {
                add: [productId],
                remove: [],
            };
            const ids = components.map((component) => component.id);
            const componentIdBatches = (0, lodash_1.chunk)(ids, 2);
            while (componentIdBatches.length) {
                const idsBatch = componentIdBatches.shift();
                if (idsBatch.length > 0) {
                    await Promise.all(idsBatch?.map((id) => (0, components_1.associateProductToComponent)(id, products)))
                        .catch(() => {
                        dispatch((0, associatedComponents_1.associateProductToComponentsError)());
                        dispatch((0, products_1.openProductsToast)({
                            status: "error",
                            message: "Error saving product",
                        }));
                    });
                }
            }
            await (0, listAssociatedComponents_1.listAssociatedComponents)(productId)(dispatch).then(() => {
                dispatch((0, associatedComponents_1.associateProductToComponentsSuccess)());
                dispatch((0, products_1.openProductsToast)({
                    status: "success",
                    message: "Saving product success",
                }));
            });
        }
        catch (error) {
            dispatch((0, associatedComponents_1.associateProductToComponentsError)());
            dispatch((0, products_1.openProductsToast)({
                status: "error",
                message: "Error saving product",
            }));
        }
    };
}
exports.associateProductToComponentsUseCase = associateProductToComponentsUseCase;
